import React from 'react';
import { useStyles } from './styles';
import { Box, Typography, Dialog, Grid, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Link } from 'react-router-dom';
import PhoneIcon from '@material-ui/icons/Phone';
import { decrypt } from '../../../helpers/encrypt';

export const SpocDetails = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
  
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.handleClose} open={props?.open}>

      <Box className={classes.root}>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Loss Mitigation Application in Progress</Typography>
        </Box>

        <Box className={classes.box}>
          <Typography className={classes.information}>It looks like you already have a loss mitigation process underway.</Typography>
          <Typography className={classes.heading}>For further assistance or updates on your current application, please contact your Single Point of Contact 
          (SPOC):</Typography>  
        </Box>
       
        <Box className={classes.transferBox}>
          <Box className={classes.allLoanDetails}>
            <Grid container>
            <Grid item md={6} xs={12} lg={6} style={{textAlign :"start"}}><span className={classes.informationText}>Name: </span></Grid>
            <Grid item md={6} xs={12} lg={6} style={{textAlign :"start"}}><span className={classes.servicerText}> {props.data.spocInformation?.spocName}</span></Grid></Grid>
           { props.data.spocInformation?.spocPhone && <Grid container>
            <Grid item md={6} xs={12} lg={6} style={{textAlign :"start", paddingTop: 10, paddingBottom: 10}}><span className={classes.informationText}>Contact Number : </span></Grid>
            <Grid item md={6} xs={12} lg={6} style={{textAlign :"start", paddingTop: 10, paddingBottom: 10}}><span className={classes.servicerText}> <PhoneIcon mr={2} className={classes.iconStyle} /><a href={"tel:" + decrypt(props.data.spocInformation?.spocPhone)} className={classes.phone}>{decrypt(props.data.spocInformation?.spocPhone)}</a></span></Grid></Grid> }
           { props.data.spocInformation?.spocEmail && <Grid container>
            <Grid item md={6} xs={12} lg={6} style={{textAlign :"start"}}><span className={classes.informationText}>Email: </span></Grid>
            <Grid item md={6} xs={12} lg={6} style={{textAlign :"start"}}><span><a className={classes.link} href={'mailto:' + decrypt(props.data.spocInformation?.spocEmail)}>{decrypt(props.data.spocInformation?.spocEmail)} </a></span></Grid></Grid> }
          </Box>
        </Box>

        <Box className={classes.box}>
         <Typography className={classes.information}>If you need further assistance or have additional questions, you can also contact our customer support team 
          by <Link className={classes.linkStyle} to='/ContactUs'>clicking here</Link>.</Typography>
        </Box>
             
          <Box className={classes.singleFooterItem}>
            <Button
              variant='contained'
              color="primary"
              className={classes.btn}
              onClick={() => props.handleClose()}
            > Got it</Button>
          </Box>
      </Box> 
   </Dialog>
  )
}


